/**
 * Commercial Readiness: Client Success Center
 * 
 * Comprehensive client onboarding and success management
 * Modules: Onboarding Wizard, Success Dashboard, Setup Checklist, Help & Resources
 */

import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import OnboardingWizard from './OnboardingWizard';
import ClientSuccessDashboard from './ClientSuccessDashboard';
import GuidedSetupChecklist from './GuidedSetupChecklist';
import HelpResources from './HelpResources';
import SupportRequestsPanel from './SupportRequestsPanel';
import {
  Sparkles,
  LayoutDashboard,
  CheckSquare,
  BookOpen,
  MessageSquareText
} from 'lucide-react';

const ClientSuccessCenter = ({ user, onNavigate }) => {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <div className="page-stack" data-testid="client-success-center">
      {/* Header */}
      <section className="hero-panel ceo-hero glass-panel noise-overlay">
        <div>
          <p className="eyebrow">Client Success & Onboarding</p>
          <h2>Client Success Center</h2>
          <p className="text-white/70 mt-2">Your complete guide to getting started and maximizing value</p>
        </div>
      </section>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList className="glass-panel">
          <TabsTrigger value="dashboard" data-testid="tab-dashboard">
            <LayoutDashboard size={16} className="mr-2" />
            Dashboard
          </TabsTrigger>
          <TabsTrigger value="onboarding" data-testid="tab-onboarding">
            <Sparkles size={16} className="mr-2" />
            Onboarding Wizard
          </TabsTrigger>
          <TabsTrigger value="checklist" data-testid="tab-checklist">
            <CheckSquare size={16} className="mr-2" />
            Setup Checklist
          </TabsTrigger>
          <TabsTrigger value="help" data-testid="tab-help">
            <BookOpen size={16} className="mr-2" />
            Help & Resources
          </TabsTrigger>
          <TabsTrigger value="support" data-testid="tab-support">
            <MessageSquareText size={16} className="mr-2" />
            Support Tickets
          </TabsTrigger>
        </TabsList>

        <TabsContent value="dashboard">
          <ClientSuccessDashboard user={user} onNavigate={onNavigate} onContinueOnboarding={() => setActiveTab('onboarding')} />
        </TabsContent>

        <TabsContent value="onboarding">
          <OnboardingWizard user={user} onNavigate={onNavigate} />
        </TabsContent>

        <TabsContent value="checklist">
          <GuidedSetupChecklist user={user} />
        </TabsContent>

        <TabsContent value="help">
          <HelpResources user={user} />
        </TabsContent>

        <TabsContent value="support">
          <SupportRequestsPanel user={user} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ClientSuccessCenter;
